import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import supabase from '../utils/supabaseClient';
import { trackEvent } from '../utils/analytics';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const redirect = params.get('redirect') || '/';
    // Wait for Supabase to finish session restoration
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        trackEvent('auth_user_authenticated', { user_id: session.user.id, email: session.user.email });
        trackEvent('auth_page_redirect', { redirect_page: redirect });
        navigate(redirect, { replace: true });
      } else {
        // Optionally show a loading spinner or error
      }
    });
  }, [navigate, location]);

  return <div>Signing you in...</div>;
} 